module.exports = __webpack_public_path__ + "static/chat-34818ea52255180334175f0de34e66e2.mp4";